import { getCardPaymentRedirect } from './card.payment.redirect.selector';
import { CreateOrderState } from './../reducers/create.order.reducer';
import { COMPLETE_ORDER_FEATURE } from './../reducers/index';
import { getOffers } from '@view-offers/store/selectors/offers.selector';
import { replacementCost } from './replacement.cost.selector';
import { getFormData } from './order.form.selector';
import { getOfferReference } from '@view-offers/store/selectors/offer.reference.selector';
import { getExtras } from '@additional-services/store/selectors/extras.selector';
import { getItemOffer } from '@additional-services/store/selectors/item.offer.selector';
import { isProtectionSelected } from '@additional-services/store/selectors/protection.selector';
import { getSelectedOffer } from '@product-details/store/selectors/selected.selector';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCompleteOrder from '@complete-order/store/reducers';
import {
  CreateOrderRequestArgs,
  Offers,
  OrderForm,
  ReplacementOffer,
  Service,
} from '@dgx-pr-spa/shared/util';
import { CardPaymentRedirect } from '../reducers/card.payment.redirect.reducer';

const getCompleteOrderState =
  createFeatureSelector<fromCompleteOrder.CompleteOrderState>(
    COMPLETE_ORDER_FEATURE
  );

export const getCreateOrderState = createSelector(
  getCompleteOrderState,
  (state) => state?.createOrder
);

export const getCreateOrder = createSelector(
  getCreateOrderState,
  (createOrder: CreateOrderState) => createOrder?.data
);

export const getCreateOrderLoading = createSelector(
  getCreateOrderState,
  (createOrder: CreateOrderState) => createOrder?.loading
);

export const getCreateOrderLoaded = createSelector(
  getCreateOrderState,
  (createOrder: CreateOrderState) => createOrder?.loaded
);

export const getCreateOrderError = createSelector(
  getCreateOrderState,
  (createOrder: CreateOrderState) => createOrder?.error
);

export const upsellData = createSelector(
  [isProtectionSelected, getItemOffer],
  (protection, itemOffer) => {
    return {
      protection,
      itemOffer,
    };
  }
);

export const getCreateOrderRequestArgs = createSelector(
  [
    getOfferReference,
    getOffers,
    replacementCost,
    getSelectedOffer,
    upsellData,
    getExtras,
    getFormData,
    getCardPaymentRedirect,
  ],
  (
    offerReference,
    offers,
    cost,
    selected,
    upsell,
    extras,
    form,
    payment
  ): CreateOrderRequestArgs => {
    return {
      offerReference: offerReference as string,
      currentPlan: (offers as Offers)?.current_plan,
      currentItem: (offers as Offers)?.current_item,
      cost: cost as number,
      selected: selected as ReplacementOffer,
      protection: (upsell as { itemOffer; protection })?.protection,
      itemOffer: (upsell as { itemOffer; protection })?.itemOffer,
      extras: extras as Service[],
      form: form as OrderForm,
      orderNumber: (payment as CardPaymentRedirect)?.response?.orderNumber,
      clientReferenceNumber: (payment as CardPaymentRedirect)?.response
        ?.clientReferenceNumber,
    };
  }
);
